import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Alert,
  Button,
  Box,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArtikelThumbnail from './ArtikelThumbnail';
import { fetchApi } from './fetchApi';

const ArtikelThumbnailAny = ArtikelThumbnail as any;

interface ArtikelOhneBestand {
  id: number;
  sku: string;
  bezeichnung: string;
  farbe: string | null;
  groesse: string | null;
  bild_url: string | null;
}

export default function ArtikelOhneBestandTabelle() {
  const [daten, setDaten] = useState<ArtikelOhneBestand[]>([]);
  const [fehler, setFehler] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchApi('/api/view/artikel-ohne-bestand')
      .then((res) => {
        if (!res.ok) throw new Error(String(res.status));
        return res.json();
      })
      .then((rows: ArtikelOhneBestand[]) => setDaten(Array.isArray(rows) ? rows : []))
      .catch((err: any) => {
        setFehler(
          err?.message === '401'
            ? 'Session abgelaufen. Bitte neu einloggen.'
            : 'Daten konnten nicht geladen werden.'
        );
        setDaten([]);
      });
  }, []);

  return (
    <Container maxWidth="md">
      <Typography variant="h5" gutterBottom mt={4} mb={2}>
        Artikel ohne Bestand
      </Typography>

      {fehler && <Alert severity="error">{fehler}</Alert>}

      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: 44 }} />
              <TableCell>SKU</TableCell>
              <TableCell>Bezeichnung</TableCell>
              <TableCell>Farbe</TableCell>
              <TableCell>Größe</TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {daten.map((a) => (
              <TableRow key={a.id}>
                <TableCell sx={{ pr: 0 }}>
                  <ArtikelThumbnailAny
                    url={a.bild_url || null}
                    alt={a.sku}
                    size={32}
                  />
                </TableCell>
                <TableCell>{a.sku}</TableCell>
                <TableCell>{a.bezeichnung}</TableCell>
                <TableCell>{a.farbe ?? '—'}</TableCell>
                <TableCell>{a.groesse ?? '—'}</TableCell>
                <TableCell align="right">
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={() => navigate(`/artikel/child/bearbeiten/${a.id}`)}
                  >
                    Bearbeiten
                  </Button>
                </TableCell>
              </TableRow>
            ))}

            {!fehler && daten.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} align="center" sx={{ opacity: 0.7 }}>
                  Keine Artikel ohne Bestand gefunden.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Paper>
    </Container>
  );
}
